import { useState } from "react";
import { Card } from "./ui/card";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { brl } from "./PurchaseDialog";
import { Gift, MapPin, Wallet, QrCode, Lock } from "lucide-react";

const API_ROOT = process.env.REACT_APP_BACKEND_URL;

const Photo = ({ b }) => {
  const [broken, setBroken] = useState(false);
  return (
    <div className="relative aspect-[4/3] bg-muted overflow-hidden">
      {b.logo_url && !broken ? (
        <img src={`${API_ROOT}${b.logo_url}`} alt={b.name} loading="lazy" onError={() => setBroken(true)}
             className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      ) : (
        <div className="h-full w-full flex items-center justify-center"><Gift className="h-12 w-12 text-amber-400/70" /></div>
      )}
      {b.discount && <Badge className="gold-btn absolute top-3 right-3 shadow" data-testid={`benefit-discount-${b.id}`}>{b.discount}</Badge>}
      <Badge variant="secondary" className="absolute top-3 left-3 backdrop-blur bg-background/80" data-testid={`benefit-category-${b.id}`}>{b.category}</Badge>
    </div>
  );
};

const Prices = ({ b }) => (
  <div className="mt-4" data-testid={`benefit-price-${b.id}`}>
    {b.original_price && (
      <div className="text-xs text-muted-foreground">De <span className="line-through" data-testid={`benefit-original-${b.id}`}>{brl(b.original_price)}</span></div>
    )}
    <div className="flex items-baseline gap-1">
      <span className="text-xs text-muted-foreground">Por</span>
      <span className="font-mono text-2xl font-bold gold-text" data-testid={`benefit-final-${b.id}`}>{brl(b.price)}</span>
    </div>
    <div className="text-[10px] uppercase tracking-[0.2em] text-emerald-500">Preço para associado</div>
  </div>
);

export const ProductCard = ({ b, index = 0, canUse, onLocked, onPay }) => (
  <Card className="group overflow-hidden flex flex-col card-hover animate-in fade-in slide-in-from-bottom-2"
        style={{ animationDelay: `${Math.min(index, 8) * 60}ms`, animationFillMode: "both" }} data-testid={`benefit-card-${b.id}`}>
    <Photo b={b} />
    <div className="p-5 flex flex-col flex-1">
      <div className="font-display text-lg font-bold leading-tight">{b.name}</div>
      {b.address && (
        <div className="mt-1 flex items-start gap-1 text-xs text-muted-foreground" data-testid={`benefit-address-${b.id}`}>
          <MapPin className="h-3 w-3 mt-0.5 shrink-0" /> <span>{b.address}</span>
        </div>
      )}
      <p className="mt-3 text-sm text-muted-foreground leading-relaxed line-clamp-3 flex-1">{b.description}</p>
      {b.price ? <Prices b={b} /> : null}
      {canUse && b.how_to_use && (
        <div className="mt-3 p-2.5 rounded-lg bg-muted/60 text-xs" data-testid={`benefit-howto-${b.id}`}>
          <b>Como usar:</b> {b.how_to_use}
        </div>
      )}
      {!canUse ? (
        <Button variant="outline" size="sm" className="mt-4" onClick={onLocked} data-testid={`benefit-locked-${b.id}`}>
          <Lock className="h-3 w-3 mr-2" /> Cadastre-se para comprar
        </Button>
      ) : b.price ? (
        <div className="mt-4 grid gap-2">
          <Button size="sm" className="gold-btn" onClick={() => onPay("saldo")} data-testid={`benefit-pay-balance-${b.id}`}>
            <Wallet className="h-3 w-3 mr-2" /> Pagar com saldo Conecta Mais
          </Button>
          <Button size="sm" variant="outline" onClick={() => onPay("pix")} data-testid={`benefit-pay-pix-${b.id}`}>
            <QrCode className="h-3 w-3 mr-2" /> Gerar PIX para pagamento
          </Button>
        </div>
      ) : null}
    </div>
  </Card>
);
